<template>
    <div class="file-card card" @click="fnFileDownload(fileUrl)">
        <div class="card-header p-0 text-center">
        
        </div>
        <div class="card-body text-center">
            <i class="lar la-file-pdf fs-2500 text-danger"></i>
        </div>
        <div class="card-footer bg-primary">
            <p class="mb-0 fs-900 fw-700">{{ formTitle }}</p>
            <p class="mb-0 fs-700 fw-500">{{ provider }}</p>
            <p class="mb-0 fs-600 fw-400">{{ other1 }}</p>
            <p class="mb-0 fs-600 fw-400">{{ other2 }}</p>
        </div>
    </div>
</template>
<script>
export default {
    props:['fileId', 'formTitle','provider','other1', 'other2', 'fileUrl'],
    components:{
       
    },
    data(){
        return{
           
        }
    },
    methods:{
        fnFileDownload:async function(fileUrl){
             window.open(`${fileUrl}`, '_blank');
        }
    }
}
</script>